import { useEffect, useState } from 'react';
/**
 * Obtem a lista de benchmarks utilizados no dropdown do botão Benchmarks
 *
 * @param loadedCarteiraList Indica se a carteiraList está carregada
 * @param carteiraList Lista com todas as carteiras
 * @param carteira Carteira selecionada
 *
 * @returns Array com label e value dos benchmarks da carteira
 */
const useCustomItemOptions = (loadedCarteiraList, carteiraList, carteira) => {
    const [options, setOptions] = useState([]);
    useEffect(() => {
        var _a, _b;
        if (loadedCarteiraList && carteiraList && carteiraList[0] && carteira) {
            const filteredBenchOptions = (_b = (_a = carteiraList.filter((item) => item.nome_portfolio.toUpperCase() === carteira.toUpperCase())[0]) === null || _a === void 0 ? void 0 : _a.CV_bench_opcao) !== null && _b !== void 0 ? _b : [];
            setOptions(filteredBenchOptions);
        }
    }, [loadedCarteiraList, carteiraList, carteira]);
    return options;
};
export default useCustomItemOptions;
